function bytestoMB(bytes: number, decimal: number) {
  // Round to nearest X decmal places using the standard method
  return Math.round((bytes / 1000000) * 10 ** decimal) / 10 ** decimal;
}

function bytesToMiB(bytes: number, decimal: number) {
  // Round to nearest X decmal places using the binary method
  return Math.round((bytes / 1024 / 1024) * 10 ** decimal) / 10 ** decimal;
}

// ! ADD NEW TECHNOLOGY
export function bytesToMegabytes(
  bytes: number,
  decimal: number,
  networkName: string
) {
  const uhp_network_names = [
    "Helium",
    "TelAlaska - Horizons 1",
    "Xenon",
    "Tristate",
    "Curis-LCS",
    "Quickspot",
    "RNDC",
    "Argon-PET",
  ];
  if (
    networkName.toLowerCase().includes("uhp") ||
    uhp_network_names.includes(networkName) ||
    // PG&E Skybits
    networkName.toLowerCase().includes("skybits") ||
    networkName.toLowerCase().includes("kore") ||
    networkName.toLowerCase().includes("oneweb") ||
    networkName.toLowerCase().includes("hammer") ||
    networkName.toLowerCase().includes("viasat") ||
    networkName.toLowerCase().includes("curis")
  ) {
    // Use binary method for networks Comtech UHP, PG&E Skybits, Kore, and OneWeb
    return bytesToMiB(bytes, decimal);
  } else {
    return bytestoMB(bytes, decimal);
  }
}
